module.exports = __webpack_public_path__ + "img/cover.6d83e8fb.png";